var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.0001V16.0001M16 20.0001H16.01M7 11.9415V20.0586C7 20.4013 7 20.5726 7.05048 20.7254C7.09515 20.8606 7.16816 20.9847 7.26463 21.0893C7.37369 21.2077 7.52345 21.2909 7.82297 21.4573L15.223 25.5684C15.5066 25.726 15.6484 25.8047 15.7985 25.8356C15.9315 25.863 16.0685 25.863 16.2015 25.8356C16.3516 25.8047 16.4934 25.726 16.777 25.5684L24.177 21.4573C24.4766 21.2909 24.6263 21.2077 24.7354 21.0893C24.8318 20.9847 24.9049 20.8606 24.9495 20.7254C25 20.5726 25 20.4013 25 20.0586V11.9415C25 11.5989 25 11.4276 24.9495 11.2748C24.9049 11.1396 24.8318 11.0155 24.7354 10.9108C24.6263 10.7925 24.4766 10.7093 24.177 10.5429L16.777 6.43177C16.4934 6.27421 16.3516 6.19543 16.2015 6.16454C16.0685 6.13721 15.9315 6.13721 15.7985 6.16454C15.6484 6.19543 15.5066 6.27421 15.223 6.43177L7.82297 10.5429C7.52345 10.7093 7.37369 10.7925 7.26463 10.9108C7.16816 11.0155 7.09515 11.1396 7.05048 11.2748C7 11.4276 7 11.5989 7 11.9415Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d2f9c2d22fae3677f8ffb3e8256ec327.svg";
export { ForwardRef as ReactComponent };